import React from 'react';
import styles from './CVHeader.module.scss';
import AutosizeInput from 'react-input-autosize';

const CVHeader = ({ onInputChangedHandler, cvFormData }) => {
    return (
        <>
            <div className="form-group w-100 mb-0 d-inline-flex">
                <label className={`${styles.FirstNameLabel}`}>
                    <AutosizeInput
                        className={`form-control ${styles.FirstNameInput}`}
                        name="firstname"
                        placeholder="Jack"
                        value={cvFormData.firstName}
                        onChange={function (event) {
                            onInputChangedHandler(event, 'firstName');
                        }}
                    />
                </label>
                <label className={`${styles.LastNameLabel}`}>
                    <AutosizeInput
                        className={`form-control ${styles.LastNameInput}`}
                        name="lastname"
                        placeholder="Sullivan"
                        value={cvFormData.lastName}
                        onChange={(event) => {
                            onInputChangedHandler(event, 'lastName');
                        }}
                    />
                </label>
            </div>
            <fieldset className="form-group mb-0">
                <label>
                    <input
                        type="text"
                        className={`${styles.Designation} form-control`}
                        name="designation"
                        value={cvFormData.designation}
                        placeholder="Programmer"
                        onChange={(event) => {
                            onInputChangedHandler(event, 'designation');
                        }}
                    />
                </label>
            </fieldset>
        </>
    );
};

export default CVHeader;
